import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { CapexItem } from 'src/app/model/capex';
import { PieGraphItem } from 'src/app/model/commodities-graph';
import { GraphContainer, GraphViews } from 'src/app/model/generic-graph';

@Component({
  selector: 'app-capex',
  templateUrl: './capex.component.html',
  styleUrls: ['./capex.component.scss']
})
export class CapexComponent {
  @Input() graphData: GraphContainer = {} as GraphContainer;
  @Input() chartId: string = '';

  public selectedItem: CapexItem = {} as CapexItem;
  public selectedIndex: number = 0;
  public options: any = {};
  public myChart: any;
  public items: CapexItem[] = []


  public basicOptions: any = {
    textStyle: {
      fontFamily: 'DemoLight',
    },
    series: [
      {
        name: 'Capex',
        type: 'pie',
        radius: [70, 90],
        itemStyle: {
          borderWidth: 3,
          borderColor: '#002947',
          color: '#01D8EA'
        },
        label: {
          show: true,
          position: 'center',
        },
        emphasis: {
          scale: false,
          label: {
            show: false,
          },
          itemStyle: {
            color: '#918EF4'
          }
        },
        data:[],
      },
      {
        name: 'Inactive',
        type: 'pie',
        radius: [83, 90],
        itemStyle: {
          borderColor: '#002949',
          borderWidth: 4,
          color: '#2C3E50',
        },
        label: {
          show: true,
          position: 'center',
        },
        emphasis: {
          scale: false,
          label: {
            show: false,
          },
          itemStyle: {
            color: 'gray'
          }
        },
        data: [],
      },
    ]
  };

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.items = (this.graphData.navigation.nav as GraphViews)[0].graph.data;
    // console.log((this.graphData.navigation.nav as GraphViews)[0].graph.data);

    this.selectedItem = (this.graphData.navigation.nav as GraphViews)[0].graph.data[this.selectedIndex];
    const pieItems = (this.graphData.navigation.nav as GraphViews)[0].graph.data;
    this.basicOptions.series[0].data = pieItems.map((item: CapexItem) => ({
      value: item.budget,
      name: item.actual,
      item: {...item},
      itemStyle: {
        opacity: item.isActive ? 1 : 0,
      }
    }));
    this.basicOptions.series[1].data = pieItems.map((item: CapexItem) => ({
      value: item.budget,
      name: item.actual,
      item: {...item},
      itemStyle: {
        opacity: !item.isActive ? 1 : 0
      }
    }));
    this.options =  {...this.basicOptions}
  }

  public onChartInit(chartInstance: any) {
    this.myChart = chartInstance;
    setTimeout(() => {
      this.eventsOnBarChart(chartInstance);
    });
    this.selectDefultItem();
  }

  public eventsOnBarChart(chartInstance: any): void {
    chartInstance.on('mouseup', 'series', (params: any) => {
      if(this.selectedIndex !== params.dataIndex) {
        this.selectItem(params.dataIndex);
      }
      this.cdr.detectChanges();
    });
  }

  private selectItem(index: number): void {
    setTimeout(() => {
        this.myChart.dispatchAction({type: 'downplay', seriesIndex: [0,1]});
        this.myChart.dispatchAction({type: 'highlight', seriesIndex: [0,1], dataIndex: [index,index]});
        this.selectedIndex = index;
        this.selectedItem = (this.graphData.navigation.nav as GraphViews)[0].graph.data[index];
        this.cdr.detectChanges();
      });
  }

  private selectDefultItem(){
    const index = (this.graphData.navigation.nav as GraphViews)[0].graph.data.findIndex((item: CapexItem) => item.isDefault);
    if(index !== -1) {
      this.selectItem(index)
    } else {
      this.selectItem(0);
    }
  }
}
